"use strict";'use strict';

var chunkWNYA6PYF_js = require('./chunk-WNYA6PYF.js');
require('./chunk-GVKDGHTM.js');



module.exports = chunkWNYA6PYF_js.Instagram_default;
